import { render, staticRenderFns } from "./UtmShareSection.vue?vue&type=template&id=4f0240ea&scoped=true"
import script from "./UtmShareSection.vue?vue&type=script&lang=js"
export * from "./UtmShareSection.vue?vue&type=script&lang=js"
import style0 from "./UtmShareSection.vue?vue&type=style&index=0&id=4f0240ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0240ea",
  null
  
)

export default component.exports